{
  "title": "Summon Construct",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (an ornate stone and metal lockbox worth at least 400 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth the spirit of a construct. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Construct Spirit stat block. When you cast the spell, choose a material: Clay, Metal, or Stone. The creature resembles a golem or a modron (your choice) made of the chosen material, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Construct Spirit",
    "Medium construct",
    "Armor Class: 13 + the level of the spell (natural armor)",
    "Hit Points: 40 + 15 for each spell level above 4th",
    "Speed: 30 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "18 (+4)",
    "10 (+0)",
    "18 (+4)",
    "14 (+2)",
    "11 (+0)",
    "5 (−3)",
    "Damage Resistances: poison",
    "Condition Immunities: charmed, exhaustion, frightened, incapacitated, paralyzed, petrified, poisoned",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Heated Body (Metal Only). A creature that touches the construct or hits it with a melee attack while within 5 feet of it takes 1d10 fire damage.",
    "Stony Lethargy (Stone Only). When a creature the construct can see starts its turn within 10 feet of the construct, the construct can force it to make a Wisdom saving throw against your spell save DC. On a failed save, the target can’t use reactions and its speed is halved until the start of its next turn.",
    "Actions",
    "Multiattack. The construct makes a number of attacks equal to half this spell’s level (rounded down).",
    "Slam. Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d8 + 4 + the spell’s level bludgeoning damage.",
    "Reactions",
    "Berserk Lashing (Clay Only). When the construct takes damage, it makes a slam attack against a random creature within 5 feet of it. If no creature is within reach, the construct moves up to half its speed toward an enemy it can see, without provoking opportunity attacks."
  ],
  "spellLists": ["artificer", "wizard"]
}
